// src/pages/PageNotFound.tsx

import React from "react";
import { Link } from "react-router-dom";
import { ROUTES } from "@/routes/routes.config";
import { AppEmptyState } from "@/design-system/Feedbacks";

const PageNotFoundTemplate: React.FC = () => {
    return (
        <div className="min-h-screen flex flex-col justify-center items-center px-4 py-8 bg-white">
            <AppEmptyState paragraphClass="px-8 pb-2" pageTitle="Page Not Found" message="Sorry, the page you're looking for doesn't exist or has been moved." />

            <Link
                to={ROUTES.HOME}
                className="mt-6 inline-flex items-center px-6 py-3 rounded-lg bg-primary text-white text-sm font-medium shadow-md hover:bg-primary-dark transition-colors"
            >
                Go to Homepage
            </Link>
        </div>
    );
};

export default PageNotFoundTemplate;
